import { useEffect } from "react";

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY;

export const usePushNotifications = (authUser:any) => {

  useEffect(() => {
    if (!authUser?._id) return;
    // No VAPID key configured for this environment — push simply stays off.
    if (!VAPID_PUBLIC_KEY) return;

    async function registerServiceWorker() {
      try {
        if (!("serviceWorker" in navigator)) return;

       const registration = await navigator.serviceWorker.register("/service-worker.js");

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });

        await fetch(`${import.meta.env.VITE_API_URL}/api/auth/save-subscription`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ subscription }),
        });
      } catch (err) {
        console.error("Push Notification Setup Error:", err);
      }
    }

    registerServiceWorker();
  }, [authUser]);
};

function urlBase64ToUint8Array(base64String:any) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
